import React from 'react';
import classNames from 'classnames';

import CatalogIcon from 'components/Common/Icons/Catalog';
import ChevronRightIcon from 'components/Common/Icons/ChevronRight';
import Trans from 'components/Common/Translation/Trans';
import CustomLink from 'components/Common/CustomLink/CustomLink';
import { getRoutesUri } from 'services/generic';

import styles from './DirectOrder.module.scss';

export default function DirectOrder({
  classes,
}: {
  classes?: Partial<{ container: string }>;
}): JSX.Element {
  return (
    <CustomLink
      to={getRoutesUri<string>('directOrder')}
      className={classNames(styles.container, classes?.container)}
    >
      <span className={styles.catalogIcon}>
        <CatalogIcon />
      </span>
      <span className={classNames(styles.content, styles.small)}>
        <Trans
          i18nKey={'CART_DIRECT_ORDER_ADD_PRODUCT'}
          namespace={'checkout'}
        />
      </span>
      <span className={classNames(styles.content, styles.large)}>
        <Trans
          i18nKey={'CART_DIRECT_ORDER_ADD_PRODUCT_LARGE'}
          namespace={'checkout'}
        />
      </span>
      <span className={styles.chevronIcon}>
        <ChevronRightIcon />
      </span>
    </CustomLink>
  );
}
